export class CashlessSolutionsWidget {
	constructor() {
		this.addEventListeners();

		setTimeout(() => {
			this.setProductsHeight();
		}, 2000);
	}

	addEventListeners() {
		window.addEventListener('resize', this.setProductsHeight);
	}

	setProductsHeight() {
		const $productsContainer = jQuery(
			'.related-solutions_desktop .ecs-posts'
		);
		if (!$productsContainer.length) {
			return;
		}

		const $productElement = jQuery(
			'.related-solutions_desktop .ecs-posts article'
		);
		const productElementsAmount = $productElement.length;

		let containerHeight = 0;
		if (productElementsAmount > 2) {
			containerHeight = $productElement.outerHeight() * 2;
		} else if (productElementsAmount <= 2 && productElementsAmount > 0) {
			containerHeight = $productElement.outerHeight();
		} else {
			containerHeight = 'auto';
		}

		$productsContainer.height(containerHeight);
	}
}
